export const I18N_COOKIE_CONTEXT = 'common';

export const COOKIE_TEXT = `cookie-text`;
export const COOKIE_BUTTON = `cookie-button`;
